<template>
  <div class="login-card__gender-card">
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">

          <div class="login-card__title-box">
            <h1 class="login-card__title">
              {{ trans.get('auth.card.gender.own.header') }}
            </h1>
            <p class="login-card__desc mb-2">
              {{ trans.get('auth.card.gender.own.subheader') }}
            </p>
          </div>

          <div class="form-row">
            <div class="form-group col-12 gender-selection">
              <validation-provider
                name="gender"
                rules="required"
                v-slot="{ errors }"
                mode="eager"
              >
                <div class="gender-selection__wrapper">
                  <input
                    type="radio" value="male"
                    id="male-gender"
                    v-model="form.gender"
                  >

                  <label
                    for="male-gender"
                    :title="trans.get('auth.card.gender.male')"
                    id="gender-male"
                  >
                    <div
                      class="button btn-block mt-3 mt-md-2 text--smedium"
                      :class="{
                        'button__fill': form.gender ==='male',
                        'button__outline--gray': form.gender !== 'male'
                      }"
                    >
                      {{ trans.get('auth.card.gender.male') }}
                      <span
                        :class="{'opacity-0': form.gender !== 'male'}"
                        class="ml-1"
                      >
                        &#10003;
                      </span>
                    </div>
                  </label>
                  <input
                    type="radio"
                    value="female"
                    id="female-gender"
                    v-model="form.gender"
                  >
                  <label
                    for="female-gender"
                    :title="trans.get('auth.card.gender.female')"
                    id="gender-female"
                  >
                    <div
                      class="button  btn-block mt-3 mt-md-2 text--smedium"
                      :class="{
                        'button__fill': form.gender === 'female',
                        'button__outline--gray': form.gender !== 'female'
                      }"
                    >
                      {{ trans.get('auth.card.gender.female') }}
                      <span
                        :class="{'opacity-0': form.gender !== 'female'}"
                        class="ml-1"
                      >&#10003;</span>
                    </div>
                  </label>
                </div>
                <p class="text-danger">{{ errors[0] }}</p>
              </validation-provider>
            </div>
          </div>

          <div class="login-card__title-box  mt-3">
            <h2 class="login-card__title">
              {{ trans.get('auth.card.gender.preferred.header') }}
            </h2>
            <p class="login-card__desc mb-2">
              {{ trans.get('auth.card.gender.preferred.subheader') }}
            </p>
          </div>

          <div class="form-row">
            <div class="form-group col-12 gender-selection">
              <validation-provider
                name="preferred gender"
                rules="required"
                v-slot="{ errors }"
                mode="eager"
              >
                <div class="gender-selection__wrapper">
                  <input
                    type="checkbox"
                    value="male"
                    id="preferred-male-gender"
                    v-model="form.preferred_gender"
                  >
                  <label
                    for="preferred-male-gender"
                    :title="trans.get('auth.card.gender.men')"
                    id="looking-for-male"
                  >
                    <div
                      class="button  btn-block mt-3 mt-md-2 text--smedium px-4"
                      :class="{
                        'button__fill': form.preferred_gender.includes('male'),
                        'button__outline--gray': !form.preferred_gender.includes('male')
                      }"
                    >
                      {{ trans.get('auth.card.gender.men') }}
                      <span
                        :class="{'opacity-0':!form.preferred_gender.includes('male')}"
                        class="ml-1"
                      >&#10003;</span>
                    </div>


                  </label>
                  <input
                    type="checkbox"
                    value="female"
                    id="preferred-female-gender"
                    v-model="form.preferred_gender"
                  >
                  <label
                    for="preferred-female-gender"
                    :title="trans.get('auth.card.gender.women')"
                    id="looking-for-female"
                  >
                    <div
                      class="button  btn-block mt-3 mt-md-2 text--smedium px-4"
                      :class="{
                        'button__fill': form.preferred_gender.includes('female'),
                        'button__outline--gray': !form.preferred_gender.includes('female')
                      }"
                    >
                      {{ trans.get('auth.card.gender.women') }}
                      <span
                        :class="{'opacity-0':!form.preferred_gender.includes('female')}"
                        class="ml-1"
                      >&#10003;</span>
                    </div>
                  </label>
                </div>
                <p class="text-danger">{{ errors[0] }}</p>
              </validation-provider>
              <div class="mt-3">
                <p class="login-card__desc mb-2">
                  {{ trans.get('auth.card.gender.search_age_text') }}
                </p>
                <div>
                  <div class="form-group text-left">
                    <label class="desc">
                      {{ trans.get('pages:members.filters_panel.age') }}
                    </label>
                    <div class="vue-slider-in">
                      <vue-slider
                        :value="[form.search.age_from || 18, form.search.age_to || 20]"
                        :min="18"
                        :max="99"
                        @change="form.search.age_from = $event[0]; form.search.age_to = $event[1]"
                      ></vue-slider>
                      <div class="vue-slider-in__number-range">
                        {{ form.search.age_from }} -
                        {{ form.search.age_to }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="button button__fill btn-block mt-3 mt-md-2 text--smedium"
          >
            {{ trans.get('auth.card.gender.continue') }}
          </button>
        </form>
      </validation-observer>

      <button
        type="button"
        class="button button__link button__link--underline mt-3 text--smedium"
        @click="goBack"
      >
        {{ trans.get('auth.card.buttons.back') }}
      </button>
    </div>
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import AuthGoBackMixin from '../../../front/components/Auth/AuthGoBackMixin';

export default {
  mixins: [AuthGoBackMixin],
  components: { VueSlider },
  props: ['swapComponent', 'form'],
  data: () => ({}),
  methods: {
    onSubmit() {
      this.swapComponent('auth-preferences-card');
    },
    goBack() {
      this.swapComponent('auth-location-card');
    }
  },
  activated() {
    this.$refs.form.reset();
    this.$emit('update:progress', 60);
    this.$emit('update:step', 3);
  },
  mounted() {

    // preload data for next card
    this.$store.dispatch('preferences/load');
  },
};
</script>
